export default __webpack_public_path__ + "static/media/register_bg_2.2dad6885.webp";